export class Saisonnalite {
  id: number;
  start: String;
  end: String;
  idCatalogueAchat: number;
}
